import activity from './activity.fr.json';
import assets from './assets.fr.json';
import auth from './auth.fr.json';
import commissions from './commissions.fr.json';
import common from './common.fr.json';
import dashboard from './dashboard.fr.json';
import payouts from './payouts.fr.json';
import profile from './profile.fr.json';
import rewards from './rewards.fr.json';
import rewardsV3 from './rewardsV3.fr.json';
import shareLink from './shareLink.fr.json';
import stats from './stats.fr.json';
import transactions from './transactions.fr.json';

const fr = {
  activity,
  assets,
  auth,
  commissions,
  common,
  dashboard,
  payouts,
  profile,
  rewards,
  rewardsV3,
  shareLink,
  stats,
  transactions,
};

export default fr;
